var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseNavItem',{attrs:{"title":_vm.$t('labels.settings'),"icon":_vm.$vuetify.icons.values.settings,"route":{ name: 'organizationSettings', params: _vm.$route.params },"visible":_vm.visible}})}
var staticRenderFns = []

export { render, staticRenderFns }